import React, { useState, useEffect } from 'react'
import { GoSearch } from 'react-icons/go'
import ChatCard from './ChatCard'
import moment from 'moment'

const ChatList = ({ handleChannelClick, activeChannel, channelList, cssChangeClass, setViewList, userStatus, showMobileConversation }) => {
    const [searchTerm, setSearchTerm] = useState('')
    const [filteredChannels, setFilteredChannels] = useState(channelList)

    useEffect(() => {
        const filtered =
            channelList &&
            channelList
                .filter(
                    channel =>
                        channel.channel.attributes &&
                        Object.keys(channel.channel.attributes).length > 0 &&
                        channel.channel.attributes.property &&
                        channel.channel.attributes.property.name.toLowerCase().includes(searchTerm.toLowerCase())
                )
                .sort((a, b) => {
                    console.log(a.lastUpdated, 'last update')
                    const dateA = new Date(a.lastUpdated || a.lastCreated).getTime()
                    const dateB = new Date(b.lastUpdated || b.lastCreated).getTime()
                    return dateB - dateA
                })

        setFilteredChannels(filtered)
    }, [searchTerm, channelList])

    return (
        <div
            className={`remove-chat-list ${showMobileConversation ? 'hidden' : ''}`}
            style={{
                display: 'flex',
                flexDirection: 'column',
                padding: '0.5rem',
                backgroundColor: '#f5f7fb',
                fontSize: '0.875rem',
                maxHeight: '100%',
                overflow: 'hidden',
            }}
        >
            <div style={{ padding: '1rem' }}>
                <h2 style={{ fontSize: '1.125rem', fontWeight: 500 }}>Chats</h2>
            </div>

            <div
                style={{
                    margin: '0.5rem 0',
                    borderRadius: '0.25rem',
                    padding: '0.25rem',
                    backgroundColor: '#ffffff',
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                <GoSearch style={{ margin: '0.5rem' }} />
                <input
                    type="text"
                    value={searchTerm}
                    onChange={e => setSearchTerm(e.target.value)}
                    style={{
                        backgroundColor: 'transparent',
                        flexGrow: 1,
                        fontSize: '0.875rem',
                        border: 'none',
                        outline: 'none',
                    }}
                    placeholder="Search"
                />
            </div>

            <div style={{ overflowY: 'scroll', flexGrow: 1 }}>
                {!filteredChannels.length && <p style={{ textAlign: 'center', margin: '2.5rem 0' }}>No Conversation Found!</p>}

                {filteredChannels.map((channel, i) => (
                    <ChatCard
                        key={i}
                        data={{
                            channelId: channel.channel.uniqueName,
                            sid: channel.channel.sid,
                            name: channel.channel.friendlyName,
                            property:
                                (channel.channel.attributes &&
                                    Object.keys(channel.channel.attributes).length > 0 &&
                                    channel.channel.attributes.property) ||
                                '',
                            lastMessageText: channel.lastMessage || '',
                            unreadMessagesCount: channel.unreadMessagesCount || 0,
                        }}
                        activeChannel={activeChannel}
                        handleChannelClick={handleChannelClick}
                        setViewList={setViewList}
                        userStatus={userStatus}
                        cssChangeClass={cssChangeClass}
                        showMobileConversation={showMobileConversation}
                    />
                ))}
            </div>
        </div>
    )
}

export default ChatList
